export default "__VITE_ASSET__dF7IC2kc__"